import React, { useState, useEffect } from "react";
import { Avatar, Typography, Box } from "@mui/material";

import { makeStyles } from 'tss-react/mui';

import { AssignmentInd, Person } from "@mui/icons-material";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles()((theme) => ({
	cardHeader: {
		cursor: "pointer",
		padding: theme.spacing(1),
		display: "flex",
		alignItems: "center",
		flex: 1,
		minWidth: 0,
	},
	avatar: {
		width: theme.spacing(5),
		height: theme.spacing(5),
		marginRight: theme.spacing(2),
		flexShrink: 0,
	},
	infoBox: {
		flex: 1,
		minWidth: 0,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
	},
	title: {
		fontWeight: 600,
		fontSize: 15,
		color: theme.palette.text.primary,
		display: "flex",
		alignItems: "center",
	},
	icon: {
		fontSize: 15,
		marginRight: theme.spacing(0.5),
		color: theme.palette.text.secondary,
	},
	subheader: {
		fontSize: 13,
		color: theme.palette.text.secondary,
	},
	select: {
		minWidth: "160px",
		marginLeft: theme.spacing(2),
	},
}));

const TicketInfo = ({ contact, ticket, onClick, isContactTyping }) => {
	const { classes } = useStyles();
	const { user } = ticket;
	const [userName, setUserName] = useState("");
	const [contactName, setContactName] = useState("");
	const [whatsappId, setWhatsappId] = useState(null);

	useEffect(() => {
		if (contact) {
			let formattedContactName = contact.name ?? "";
			if (document.body.offsetWidth < 600 && formattedContactName.length > 10) {
				formattedContactName = `${formattedContactName.substring(0, 10)}...`;
			}
			setContactName(formattedContactName);

			if (user && user.name) {
				setUserName(user.name);
			}
			setWhatsappId(ticket?.whatsappId);
		}
	}, [contact, user, ticket]);



	const handleUpdateTicket = async (whatsappId) => {
		try {
			setWhatsappId(whatsappId);
			await api.put(`/tickets/${ticket.id}`, {
				whatsappId
			});
		} catch (err) {
			toastError(err);
		}
	}

	return (
		<Box className={classes.cardHeader} onClick={onClick}>
			<Avatar
				src={contact.profilePicUrl || ""}
				alt="Contact"
				className={classes.avatar}
			/>
			<Box className={classes.infoBox}>
				<Typography className={classes.title} noWrap>
					{`${contactName}`}
				</Typography>
				<Typography className={classes.subheader} noWrap style={isContactTyping ? { color: "#25d366", fontStyle: "italic" } : undefined}>
					{isContactTyping ? "escribiendo..." : (
						<>
							{`Ticket #${ticket.id}`} {userName && `- ${userName}`}
							{ticket.whatsappLast?.name && ` - Última conexión: ${ticket.whatsappLast.name}`}
						</>
					)}
				</Typography>
			</Box>

		</Box>
	);
};

export default TicketInfo;
